var render = function render(){var _vm=this,_c=_vm._self._c;return _c('full-template',{attrs:{"parent-styles":{ height: '100vh', backgroundColor: '#FFFFFF' }}},[_c('div',{staticClass:"redirect"},[(_vm.isConnecting)?_c('section-connect',{attrs:{"company-name":_vm.companyName}}):_c('span',[_vm._v("Redireccionando...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }